export default __webpack_public_path__ + "static/media/ubuntu-removebg.9cf51dc4.png";